module.exports = __webpack_public_path__ + "img/price-topic.b31ed526.png";